import { localStorageService } from '@trader/services';
import { LOCAL_STORAGE_KEYS } from '@trader/constants';
import { useMst } from '@trader/store';

export const useAppVersion = () => {
  const store = useMst();
  const currentAppVersion = import.meta.env.VITE_APP_VERSION;
  const storageAppVersion = localStorageService.get(LOCAL_STORAGE_KEYS.version);

  if (
    store.auth.isAuth &&
    Number(storageAppVersion) !== Number(currentAppVersion)
  ) {
    store.auth.logOut();
    localStorageService.remove(LOCAL_STORAGE_KEYS.persist);
    window.location.reload();
  }
};
